import React, { useState } from "react";
import toast from "react-hot-toast";
import { api } from "../../utils/axios-instance";

export default function ResubmitModal({
  deliverable,
  isOpen,
  onClose,
  onSuccess,
  roomId,
}) {
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleClose = () => {
    if (isSubmitting) return;
    setComment("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!deliverable?.id || !comment.trim() || isSubmitting) return;

    setIsSubmitting(true);
    try {
      await api.post(
        `/vendors/rooms/deliverables/${deliverable.id}/resubmit/`,
        {
          comment: comment.trim(),
          status: "pending",
          roomId: roomId,
        }
      );
      toast.success("Deliverable moved back to pending review");
      setComment("");
      onSuccess?.();
      onClose();
    } catch (err) {
      toast.error(
        err.response?.data?.error || "Failed to resubmit deliverable"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#ffffff",
          borderRadius: "12px",
          padding: "24px",
          width: "440px",
          maxWidth: "90vw",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <div>
          <h3
            style={{
              margin: "0 0 4px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#111827",
            }}
          >
            Resubmit "{deliverable?.name}"
          </h3>
          <p style={{ margin: 0, fontSize: "12px", color: "#6b7280" }}>
            This moves the deliverable back to pending review so the client can
            take another look.
          </p>
        </div>

        <div>
          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontSize: "12px",
              fontWeight: "600",
              color: "#374151",
            }}
          >
            Note for Client / Rejection Response
          </label>
          <textarea
            required
            rows={4}
            placeholder="Explain what changed since the last submission..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              border: "1px solid #e5e7eb",
              borderRadius: "6px",
              fontSize: "13px",
              color: "#111827",
              resize: "vertical",
              fontFamily: "inherit",
            }}
          />
        </div>

        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <button
            type="button"
            onClick={handleClose}
            disabled={isSubmitting}
            style={{
              background: "transparent",
              border: "none",
              color: "#6b7280",
              padding: "8px 16px",
              fontSize: "13px",
              cursor: isSubmitting ? "not-allowed" : "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSubmitting || !comment.trim()}
            style={{
              background: "#5E5ADB",
              color: "#fff",
              border: "none",
              padding: "8px 20px",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: "600",
              cursor:
                isSubmitting || !comment.trim() ? "not-allowed" : "pointer",
              opacity: isSubmitting || !comment.trim() ? 0.6 : 1,
            }}
          >
            {isSubmitting ? "Submitting..." : "Move to Pending"}
          </button>
        </div>
      </form>
    </div>
  );
}
